
import "../../src/PG_StaticHomePage/PG.css"
import React, { useState, useEffect, useCallback, useRef } from 'react';


const bannerImages = [
  '/Generic_Banner.png',
  '/Gate_Banner.png',
  '/GateBanner1.png',
  '/IITJAMBannerImg.png',
];

const AUTO_SCROLL_INTERVAL = 4000;

const PgHeroSection = ({onExploreExams}) => {
  



  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const intervalRef = useRef(null);

  const totalSlides = bannerImages.length;

  const goToSlide = useCallback((index) => {
    setCurrentSlide(index);
  }, []);

  const goNext = useCallback(() => {
    setCurrentSlide((prev) => (prev + 1) % totalSlides);
  }, [totalSlides]);

  const goPrev = useCallback(() => {
    setCurrentSlide((prev) => (prev - 1 + totalSlides) % totalSlides);
  }, [totalSlides]);

  useEffect(() => {
    if (isPaused) return;
    intervalRef.current = setInterval(goNext, AUTO_SCROLL_INTERVAL);
    return () => clearInterval(intervalRef.current);
  }, [isPaused, goNext]);

  const handleMouseEnter = () => setIsPaused(true);
  const handleMouseLeave = () => setIsPaused(false);

  const handleTouchStart = () => setIsPaused(true);
  const handleTouchEnd = () => {
    setTimeout(() => setIsPaused(false), 3000);
  };

  return (
    <section >
      <div >
        {/* <div className="ug-hero-content">
        
          <div className="ug-hero-left">
            <h1>
              Crack India's Top
              <br />
              UG Entrance Exams
            </h1>

            <p>
              Prepare for JEE, NEET, BITSAT, VITEEE, KCET, EAPCET and
              20+ entrance exams with chapter-wise practice, mock tests,
              and detailed solutions.
            </p>

            <div className="ug-hero-buttons">
              <button
                className="primary-btn"
                onClick={onExploreExams}
              >
                Explore Exams
              </button>
              <button
                className="secondary-btn"
                onClick={() =>
                  window.open(
                    "https://onlineug.egradtutor.in/MockTest",
                    "_blank"
                  )
                }
              >
                Try Free Mock Test
              </button>
            </div>
          </div>

         
          <div className="ug-hero-right">
            <img
              src="/UGHeroImg.png"
              alt="UG Entrance Exams"
            />
          </div>
        </div> */}

        {/* Banner Carousel */}
        <div
          className="banner-carousel"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
        >
          <div className="banner-carousel-viewport">
            {bannerImages.map((src, index) => (
              <div
                key={index}
                className={`banner-slide ${index === currentSlide ? 'banner-slide-active' : ''}`}
              >
                <img src={src} alt={`Banner ${index + 1}`} draggable={false} />
              </div>
            ))}
          </div>

          {/* Prev Arrow */}
          <button
            className="banner-arrow banner-arrow-prev"
            onClick={goPrev}
            aria-label="Previous banner"
          >
            &#10094;
          </button>

          {/* Next Arrow */}
          <button
            className="banner-arrow banner-arrow-next"
            onClick={goNext}
            aria-label="Next banner"
          >
            &#10095;
          </button>

          {/* Dots */}
          <div className="banner-dots">
            {bannerImages.map((_, index) => (
              <button
                key={index}
                className={`banner-dot ${index === currentSlide ? 'banner-dot-active' : ''}`}
                onClick={() => goToSlide(index)}
                aria-label={`Go to banner ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};



export default PgHeroSection